document.documentElement.classList.remove('no-js');
document.documentElement.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
    button.addEventListener('click', () => {
      const gallery = button.closest('[data-product-gallery]');
      const main = gallery && gallery.querySelector('[data-gallery-main]');
      if (!main) return;
      main.src = button.dataset.imageSrc;
      main.srcset = '';
      main.alt = button.dataset.imageAlt || main.alt;
      gallery.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => thumb.classList.remove('is-active'));
      button.classList.add('is-active');
    });
  });

  document.querySelectorAll('.mobile-menu__panel a').forEach((link) => {
    link.addEventListener('click', () => {
      const details = link.closest('details');
      if (details) details.removeAttribute('open');
    });
  });
});
